import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Flex, Heading, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { Helmet } from 'react-helmet'
import Lottie from 'react-lottie'

import useUserAuth from '@hook/shared/use-user-auth'

import Animation from '../animations/not-authorized.json'

const NotAuthorized: FC = () => {
  const { logout } = useAuth0()

  const { setLogout } = useUserAuth()

  // }
  // useEffect(() => {
  //   ;(async function login() {
  //     if (!isLoading && !user) {
  //       await loginWithRedirect()
  //     }
  //   })()
  // }, [isLoading])
  return (
    <>
      <Helmet>
        <title>manutencao - SCL</title>
      </Helmet>
      <Box bg="green.600" h="100vh" overflowY="auto" color="gray.800">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          bg="green.600"
          borderRadius="8px"
          h="calc(100vh - 8px)"
          p={6}
        >
          <Lottie
            width={900}
            options={{
              loop: true,
              autoplay: true,
              animationData: Animation
            }}
          />

          <Heading
            mb={5}
            fontSize={['40px', '40px', '50px']}
            fontWeight="800"
            color="white"
          >
            Oops! Sem Autorizacao
          </Heading>
          <Text
            maxW="460px"
            fontSize="18px"
            textAlign="center"
            fontWeight="800"
            color="white"
          >
            Por Favor entre em contato com nosso time de Admistrador do Sistema
            para solicitar o cadastro
          </Text>

          <br></br>
          <Button
            backgroundColor={'yellow.100'}
            onClick={() => {
              setLogout(true)
              logout({ returnTo: window.location.origin })
            }}
          >
            Sair do Sistema
          </Button>
        </Flex>
      </Box>
    </>
  )
}

export default NotAuthorized
